import { defineStore } from 'pinia'
import { ref } from 'vue'
import { type PaymentMethod, type User, type Address } from '@repo/api-types'
import { useAccount } from '@/composables/useAccount'

export const useAccountStore = defineStore('account', () => {
  const userDefaultAddress = ref<Address>()
  const userDefaultPaymentMethod = ref<PaymentMethod>()
  const user = ref<User>()
  const loading = ref(false)

  const load = async () => {
    loading.value = true
    const results = await Promise.all([
      useAccount().getDefaultCustomerAddress(),
      useAccount().getDefaultPaymentMethod(),
      useAccount().getUser(),
    ])

    // TODO: Move to error  handling
    if (results[0].error) {
      console.log('Getting user default address error: ', results[0].error)
    } else {
      userDefaultAddress.value = results[0].result
    }

    if (results[1].error) {
      console.log('Getting user payment default method error: ', results[1].error)
    } else {
      userDefaultPaymentMethod.value = results[1].result
    }

    if (results[2].error) {
      console.log('Getting user error: ', results[2].error)
    } else {
      user.value = results[2].result
    }

    loading.value = false
  }

  return {
    loading,
    load,
    userDefaultAddress,
    userDefaultPaymentMethod,
    user,
  }
})
